// @ts-nocheck -- Transitional typing for a legacy JavaScript module.
import { useState } from "react";
import { Columns3, Filter, List } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import SearchField from "@/components/common/SearchField";
import { Select, SelectContent, SelectGroup, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { cn } from "@/utils/common.utils";

export default function DealControls({ search, onSearchChange, sideFilter, onSideFilterChange, view, onViewChange }) {
  const [showFilters, setShowFilters] = useState(false);
  const activeFilterCount = sideFilter === "all" ? 0 : 1;

  return (
    <section className="flex flex-col gap-4 lg:flex-row lg:items-start lg:justify-between" aria-label="Deal controls">
      <div className="flex w-full flex-col gap-3 sm:flex-row lg:max-w-2xl">
        <SearchField className="flex-1" value={search} onChange={(event) => onSearchChange(event.target.value)} onClear={() => onSearchChange("")} placeholder="Search deals, clients, agents, addresses…" testId="dashboard-search" />
        <div className="relative">
          <Button type="button" variant="dashboardOutline" size="lg" className="h-11 !rounded-xl" onClick={() => setShowFilters((open) => !open)} aria-expanded={showFilters}>
            <Filter data-icon="inline-start" /> Filters
            {activeFilterCount > 0 && <Badge variant="secondary" className="rounded-full">{activeFilterCount}</Badge>}
          </Button>
          {showFilters && (
            <div className="absolute left-0 top-12 z-20 w-64 rounded-xl border border-dash-border bg-white p-4 shadow-lg">
              <label className="text-xs font-semibold text-dash-ink" htmlFor="deal-side-filter">Transaction side</label>
              <Select value={sideFilter} onValueChange={onSideFilterChange}>
                <SelectTrigger id="deal-side-filter" className="mt-2"><SelectValue /></SelectTrigger>
                <SelectContent><SelectGroup><SelectItem value="all">All deals</SelectItem><SelectItem value="buy">Buyers</SelectItem><SelectItem value="sell">Sellers</SelectItem></SelectGroup></SelectContent>
              </Select>
            </div>
          )}
        </div>
      </div>
      <div className="inline-flex self-start rounded-xl border border-dash-border bg-dash-searchBg p-1" aria-label="View options">
        <Button variant="seamless" type="button" onClick={() => onViewChange("board")} className={cn("inline-flex items-center gap-2 rounded-lg px-4 py-2 text-sm font-medium", view === "board" ? "bg-white text-dash-ink shadow-sm" : "text-dash-muted")} aria-pressed={view === "board"} data-testid="dashboard-board-view"><Columns3 className="size-4" /> Board</Button>
        <Button variant="seamless" type="button" onClick={() => onViewChange("table")} className={cn("inline-flex items-center gap-2 rounded-lg px-4 py-2 text-sm font-medium", view === "table" ? "bg-white text-dash-ink shadow-sm" : "text-dash-muted")} aria-pressed={view === "table"} data-testid="dashboard-table-view"><List className="size-4" /> Table</Button>
      </div>
    </section>
  );
}
